import React, { useEffect, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { Input } from "@vds/inputs";
import { setAlertGroupDetail, setCurrentModal } from "../../../../store/actions/alertsGroup"; 
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../../global/constants/inputLimits";
import { validateAlertsGroupAPI } from "../../../../global/utility/Utils";
import { useSelector } from "react-redux";

function AlertGroupDetails({}) {
    const [alertGroupName, setAlertGroupName] = useState({});
    const [description, setDescription] = useState({});
    const dispatch = useDispatch();
    const currentModal = useSelector(state=>state.alertsGroup.currentModal);

    const handleGroupName = (val) => {
        if(val.trim()==''||val==undefined){
            setAlertGroupName({val,
                hasError:'Enter Valid Value'
            })
        }else{
            setAlertGroupName({
                val,
                hasSuccess:true
            })
        }
    }

    const handleDescription = (val) => {
        if(val.trim()?.length>250){
            setDescription({val,
                hasError:'Enter Valid Value'
            })
        }else{
            setDescription({
                val,
                hasSuccess:true
            })
        }
    }
    const alertGroupDetail = useSelector(state=>state.alertsGroup.alertGroupDetail);

    useEffect(()=>{
            setAlertGroupName({val: alertGroupDetail?.alertGroupName});
            setDescription({val:alertGroupDetail?.description});
            //dispatch(setAlertGroupDetail({userList:alertGroupDetail?.users?.map(user=>user?.key)}))
    },[alertGroupDetail]);


    const vi = useSelector(state=>{
        return state;
    })

    const handleNext = async () => {
        if (alertGroupName?.hasError || description?.hasError || !alertGroupName?.val) return;
        const editModes = ['EditAlertGroupModal', 'AlertGroupDetailModal'];
        const isEditMode = editModes.includes(currentModal);
        const isNameChanged = alertGroupName?.val !== alertGroupDetail?.alertGroupName;
        if (!isEditMode || (isEditMode && isNameChanged)) {
            const response = await validateAlertsGroupAPI(alertGroupName?.val);
            if (response?.status !== 200) {
                setAlertGroupName({
                    val: alertGroupName?.val,
                    hasError: 'Alert Group Name already exists'
                });
                return;
            }
        }
        dispatch(setAlertGroupDetail({
            alertGroupName: alertGroupName?.val,
            description: description?.val
        }));
        dispatch(setCurrentModal('EditUserListModal'));
    }

    return <><Grid2
        container
        marginTop={1}
        marginBottom={2}
        spacing={1}
        columns={{ xs: 12 }}
    >
        <Grid2 item xs={12}>
            <div className="mb-3">
                <label htmlFor="alertGroupName" className="input-label-user">
                    Alert Group Name
                </label>
                <Input
                    id="alertGroupName"
                    type="text"
                    value={alertGroupName?.val || ""}
                    required={false}
                    onBlur={() => handleGroupName(alertGroupName?.val)}
                    onChange={(e) => handleGroupName(e?.target?.value)}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    error={!!alertGroupName?.hasError}
                    errorText={alertGroupName?.hasError || ""}
                />
                {getCharLimitMsgIfExceeded("CATEGORY_TEXT", alertGroupName?.val || "")}
            </div>
        </Grid2>

        <Grid2 item xs={12}>
            <div className="mb-3">
                <label htmlFor="lastName" className="input-label-user">
                    Description <span class="light-grey-text-color">Optional</span>
                </label>
                <div className="input-container">
                    <Input
                        id="description"
                        value={description?.val || ""}
                        onChange={(e) => handleDescription(e?.target?.value)}
                        onBlur={() => handleDescription(description?.val)}
                        required={false}
                        maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXTAREA}
                    />
                    {getCharLimitMsgIfExceeded("CATEGORY_TEXTAREA", description?.val || "")}
                </div>
            </div>
        </Grid2>
    </Grid2>
        <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
        >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                    <Button
                        className="custom-button-cancel"
                        type="default"
                        onClick={()=>dispatch(setCurrentModal(''))}
                        shape="round"
                        style={{ fontWeight: "bold", width: "100%" }}
                        size={"large"}
                    >
                        Cancel
                    </Button>
                </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={()=>handleNext()}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  Next
                </Button>
              </div>
            </Grid2>
        </Grid2>
    </>
}

export default AlertGroupDetails;